export const environment = {
  production: true,
  API_URL: "https://qudosconnect_dev.ridequdos.com/"
};
